import React, {useEffect, useRef, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {setLookIntroStep, setLookOverlayOpened} from "../../../actions/lookFunctions";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../look/core/constants";
import {getCommonVisualizerType, IS_QKB_UI} from "../../../config";
import {setLookAiImageOpened} from "../aiActions";
import LookIntroPopper from "../../look/lookNavigation/lookIntro/lookIntroPopper";
import {imageIsRenderedAndUserIsNotLoggedIn} from "../aiFunctions";
let animationTimeout = null;


const LookSideBarAIPanel = (props) => {

  const {setLookOverlayOpened, disabled, introStep, setLookIntroStep, sidebarButtonClicked, lookOverlayOpened, isMobile,
    lookAiRenderFinished, aiResults, setLookAiImageOpened, fabricatorData, userIsLoggedIn, aiLoading} = props;
  const anchorRef = useRef(null);

  const [animationActive, setAnimationActive] = useState(false);
  const [animationShown, setAnimationShown] = useState(false);

  useEffect(() => {
    if (!fabricatorData.aiSettings.enableAI) {
      return
    }
    if (aiLoading && !lookOverlayOpened && !animationShown) {
      setAnimationShown(true);
      clearTimeout(animationTimeout);
      setAnimationActive(true);
      animationTimeout = setTimeout(() => {
        setAnimationActive(false);
      }, 2750)
    }
    return () => {
      clearTimeout(animationTimeout)
    }
  }, [fabricatorData, aiLoading, lookOverlayOpened, animationShown]);

  if (!fabricatorData.aiSettings.enableAI) {
    return null;
  }

  const realDisabled = disabled || ((introStep !== LOOK_INTRO_STEPS.welcome) && (introStep !== LOOK_INTRO_STEPS.aiStep));
  const visualizerType = getCommonVisualizerType();
  const placement = "right";
  const activeResult = lookAiRenderFinished ? aiResults.find(aiResult => aiResult.isActive) : null;
  const showLeadOverlay = !userIsLoggedIn && !document.kvConfig.isBackend;

  const aiPanelClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidePanelAIClicked);
    if (introStep === LOOK_INTRO_STEPS.aiStep) {
      setLookIntroStep();
      return false;
    }
    setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
    if (lookAiRenderFinished || imageIsRenderedAndUserIsNotLoggedIn(showLeadOverlay, aiResults)) {
      setLookAiImageOpened(true);
    }
    if (sidebarButtonClicked) {
      sidebarButtonClicked();
    }
  }

  return (
    <div ref={anchorRef}
         className={"cursor-pointer look-ai__sidebar transition2 relative"
      + (lookOverlayOpened === LOOK_OVERLAYS.aiPanel ? " look-ai__sidebar--hidden" : "")
      + (IS_QKB_UI ? " fixed top-50 look-ai__sidebar--qkb" : "")
      + (animationActive ? " look-ai__sidebar--teaser" : "")
      + (lookAiRenderFinished ? " look-ai__sidebar--finished-rendering" : "")}
         onClick={realDisabled ? null : aiPanelClick}>
      {lookAiRenderFinished ? (
        <div className="look-ai__sidebar-content rounded-05 h-full bg-center bg-cover"
             style={activeResult && activeResult.resultImageUrl ? {backgroundImage: `url(${activeResult.resultImageUrl})`} : null}>
          {activeResult && activeResult.resultImageUrl && showLeadOverlay ?
            <div className="look-ai__overlay-blur bg-center bg-cover h-full look-ai__sidebar-content rounded-05"
                 style={{backgroundImage: `url(${activeResult.resultImageUrl})`}}/> : null}
        </div>
      ) : (
        <div className="look-ai__sidebar-content pr-1 pl-1 h-full flex flex--column flex--center">
          <div className="look-ai__title leading-1 bold flex flex--center gap-025">
            <CreateNewFolderOutlinedIcon/>
            <span><FormattedMessage id="look.ai.sidebar.title"/></span>
          </div>
          <span className="look-ai__text leading-1">
            <FormattedMessage id={isMobile ? "look.ai.sidebar.mobile.text" : "look.ai.sidebar.text"}/>
          </span>
          <div className="w-175 absolute flex nowrap flex--center look-ai__sidebar-text text-capitalize bold">
            <FormattedMessage id="look.ai.sidebar.rotateText" values={{visualizerType}}/>
          </div>
        </div>
      )}
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={LOOK_INTRO_STEPS.aiStep}
                       toolTipText={"look.intro.aiStep.tooltip"}
                       visualizerType={visualizerType}/>
      <Popper open={lookAiRenderFinished}
              className={"look-step look-step--" + placement}
              anchorEl={anchorRef.current}
              placement={placement}
              transition
              disablePortal>
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === "right" ? "right center" : "left center" }}>
            <div className="look-step__content">
              <span className={"look-step__content-text text-uppercase look-step__content-text--" + placement}>
                <FormattedMessage id="Your Kitchen Render is Complete"  values={{visualizerType}}/>
              </span>
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme, isMobile} = store.serverState;
  const {lookLayoutOpened, introStep, lookOverlayOpened} = store.lookState;
  const {lookAiRenderFinished, aiResults, aiLoading} = store.aiState;
  const fabricatorData = store.fabricatorState;
  const {userIsLoggedIn} = store.userState;

  return {
    activeTheme,
    isMobile,
    lookLayoutOpened,
    introStep,
    fabricatorData,
    lookOverlayOpened,
    lookAiRenderFinished,
    aiResults,
    userIsLoggedIn,
    aiLoading,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookIntroStep,
  setLookAiImageOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookSideBarAIPanel)
)
